import { render, staticRenderFns } from "./SecForm.vue?vue&type=template&id=04ac419b&scoped=true"
import script from "./SecForm.vue?vue&type=script&lang=js"
export * from "./SecForm.vue?vue&type=script&lang=js"
import style0 from "./SecForm.vue?vue&type=style&index=0&id=04ac419b&prod&lang=css&scoped=true"
import style1 from "./SecForm.vue?vue&type=style&index=1&id=04ac419b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac419b",
  null
  
)

export default component.exports